import {RootState} from '../rootReducer';

export const scenarioGroupSelector = (state: RootState) => state.scenarioGroup;
